import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Sign from '@/components/Sign'
import Home from '@/components/Home'
import firebase from 'firebase/app'
import VueAnalytics from 'vue-analytics'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '*',
      component: Home
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { authedRedirect: true }
    },
    {
      path: '/main',
      name: 'Maim',
      component: Main,
      meta: { requiresAuth: true }
    },
    {
      path: '/sign',
      name: 'Signin',
      component: Sign,
      meta: { authedRedirect: true }
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        next({
          path: '/sign',
          query: { redirect: to.fullPath }
        })
      }
    })
  } else if (to.matched.some(record => record.meta.authedRedirect)) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next({
          path: '/main'
        })
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-131204433-1',
  router
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js